"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var areEqual = function areEqual(prev, next) {
  return prev.children === next.children && prev.isOpen === next.isOpen && prev.borderPosition === next.borderPosition;
};

var DropdownMetaItem = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var children = _ref.children,
      shouldHaveNoBorder = _ref.shouldHaveNoBorder,
      borderPosition = _ref.borderPosition,
      isOpen = _ref.isOpen;
  return (0, _core.jsx)(_helperComponents.DropdownMetaItemStyle, {
    shouldHaveNoBorder: shouldHaveNoBorder,
    borderPosition: borderPosition // If the header and footer unmount when the dropdown menu closes,
    // it's not possible to put interactive elements inside because the
    // element unmounts before the click event finishes firing.
    ,
    display: isOpen ? 'block' : 'none',
    "aria-hidden": !isOpen
  }, children);
}, areEqual);
var _default = DropdownMetaItem;
exports.default = _default;